import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
class ListCategory extends Component {
  renderListCategory = () => {
    return this.props.list.map((item) => {
      return (
        <tr key={item.id}>
          <td>
            <div className="text-sm text-gray-500">{item.name}</div>
          </td>
          <td>
            <div className="text-sm text-gray-500">{item.species}</div>
          </td>
          <td>
            <div className="text-sm text-gray-500">{item.gender}</div>
          </td>
        </tr>
      );
    });
  };
  render() {
    return (
      <div className="flex flex-col flex-Child">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      NAME
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      SPECIES
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      GENDER
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {this.renderListCategory()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const withStore = connect(
  (state) => ({
    list: state.category.category,
  }),
  null
);

export default compose(withStore)(ListCategory);
